import { render, staticRenderFns } from "./AddPickupStr.vue?vue&type=template&id=037bd3e4&scoped=true&"
import script from "./AddPickupStr.vue?vue&type=script&lang=js&"
export * from "./AddPickupStr.vue?vue&type=script&lang=js&"
import style0 from "./AddPickupStr.vue?vue&type=style&index=0&id=037bd3e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037bd3e4",
  null
  
)

export default component.exports